import { render } from "./AvatarPanel.vue?vue&type=template&id=0fe57786&scoped=true&ts=true"
import script from "./AvatarPanel.vue?vue&type=script&lang=ts"
export * from "./AvatarPanel.vue?vue&type=script&lang=ts"

import "./AvatarPanel.vue?vue&type=style&index=0&id=0fe57786&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe57786"]])

export default __exports__